import type { ClientRow } from '../../context/ClientManagementContext';
import { OverviewContactSection } from './OverviewContactSection';
import { OverviewOriginSection } from './OverviewOriginSection';
import { AddressCard, FinancialCard, PersonalExtraCard } from './OverviewProfileSections';
import { PreferencesCard } from './PreferencesCard';
import { ClientNotesSection } from './ClientNotesSection';

interface OverviewTabProps {
  client: ClientRow;
  agencyId: string;
}

/** Two cards abreast on a wide column, stacked once it narrows. */
const PAIR_CLASS = 'grid grid-cols-[repeat(auto-fit,minmax(min(100%,260px),1fr))] gap-(--space-4)';

/**
 * Client overview: contact and origin across the column, then the two
 * pairs that belong together — who the client is and where they live,
 * what they can spend and what they are looking for — and the notes.
 *
 * The Social chat launcher lives in ClientProfileContent instead of here,
 * so it stays visible across every client-detail sub-tab, not just this
 * one.
 */
export function OverviewTab({ client, agencyId }: OverviewTabProps) {
  return (
    <div className="flex flex-col gap-(--space-4)">
      <OverviewContactSection client={client} />
      <OverviewOriginSection client={client} />

      <div className={PAIR_CLASS}>
        <PersonalExtraCard client={client} />
        <AddressCard client={client} />
      </div>

      <div className={PAIR_CLASS}>
        <FinancialCard client={client} />
        <PreferencesCard client={client} />
      </div>

      <ClientNotesSection agencyId={agencyId} clientId={client.client_id} />
    </div>
  );
}
